import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../../Context/ConfigContext";
import { NoRecords } from '../../../Components/Shimmer';



class WorkExperienceView extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      company_name: '',
      experience_period: '',
      last_CTC: '',
      designation: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSubmit: false,
      keyword: "",
      from_date: "",
      to_date: "",

      reference1: {
        name: '',
        contact: '',
        email: ''
      },
      reference2: {
        name: '',
        contact: '',
        email: ''
      },
      reference3: {
        name: '',
        contact: '',
        email: ''
      },
      errors: {},
      data:[],
    };
    this.closeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ data: this.props.data }, (prevState) => {
    //   this.GetList();
    });
  }

  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleReferenceChange = (e, referenceName) => {
    const { name, value } = e.target;

    // Update the specific reference state
    this.setState((prevState) => ({
      [referenceName]: {
        ...prevState[referenceName],
        [name]: value
      }
    }));
  };

  // Handler function for Select component change
  handleSelectChange = (name, selectedOption) => {
    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };


  // Handler function for form submission
  handleSubmit = (e) => {
    e.preventDefault();
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const employee_id = this.props.params.employee_id;
    const errors = this.validateForm();
    console.log(`Object.keys(errors).length`, Object.keys(errors).length);
    if (Object.keys(errors).length > 0) {
      // If there are validation errors, update the state with the errors
      this.setState({ errors });
      return;
    }
    this.setState({loadingSubmit:true});
    var formData = {
      employee_id: employee_id,
      company_name: this.state.company_name,
      last_designation: this.state.designation,
      experience_period: this.state.experience_period,
      last_ctc: this.state.last_CTC,
      employee_work_experience_references: [
        this.state.reference1,
        this.state.reference2,
        this.state.reference3
      ]
    };

    axios.post(`${apiURL}Employees/CreateEmployeeWorkExperience`, formData, { headers }).then((response) => {
      const { success } = response.data;

      if (success === true) {
        this.setState({
          company_name: '',
          designation: '',
          experience_period: '',
          last_CTC: '',
          employee_work_experience_document_references: '',
          loadingSubmit:false,
        });
        this.closeRef.current.click();

        this.setState({ loadingList: true }, (prevState) => {
          this.GetList();
        })
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
        this.setState({ loadingList: true,loadingSubmit:false }, (prevState) => {
          this.GetList();
        })
      }

    }).catch((error)=>{
      console.log("Employees/CreateEmployeeWorkExperience ERROR:",error);
      Swal.fire({
        title: `<strong>Failed</strong>`,
        text: "Opps...! Something went wrong!",
        icon: 'error',
        showConfirmButton: true,
        allowOutsideClick:false
      })
    })
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeeWorkExperiences`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          employee_id: this.props.params.employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to Delete this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_work_experience_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployeeWorkExperience`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  validateForm = () => {
    const errors = {};
    const numberRegex = /^\d+(\.\d+)?$/;
    const mobileRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format

    if (!this.state.company_name) errors.company_name = 'Previous Company Name is required';
    if (!this.state.designation) errors.designation = 'Designation is required';
    if (!this.state.experience_period) errors.experience_period = 'Experience Period is required';
    if (this.state.experience_period && !numberRegex.test(this.state.experience_period)) errors.experience_period = 'Experience Period must be a number';
    if (!this.state.last_CTC) errors.last_CTC = 'Last CTC is required';
    if (!numberRegex.test(this.state.last_CTC)) errors.last_CTC = 'Last CTC must be a number';

    const references = ['reference1', 'reference2', 'reference3'];

    references.forEach((reference, index) => {
      const ref = this.state[reference];
      const refErrors = {};

      if (ref && (ref.name || ref.contact || ref.email)) {
        if (!ref.name) refErrors.name = `Reference ${index + 1} Name is required`;
        if (!ref.contact) {
          refErrors.contact = `Reference ${index + 1} Contact is required`;
        } else if (!mobileRegex.test(ref.contact)) {
          refErrors.contact = `Reference ${index + 1} Contact is invalid`;
        }
        if (!ref.email) {
          refErrors.email = `Reference ${index + 1} Email is required`;
        } else if (!emailRegex.test(ref.email)) {
          refErrors.email = `Reference ${index + 1} Email must be a valid email address`;
        }
      }

      if (Object.keys(refErrors).length > 0) {
        errors[reference] = refErrors;
      }
    });

    return errors;
  };




  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList(); // This will log the updated state value
      }
    );
  };
  render() {
    const { errors } = this.state;

    return (
      <>
        <div className='d-flex justify-content-between align-items-center'>
          <div>
            <h5>Work Experience</h5>
          </div>
        </div>
        <div className="card-body">
          <table className={`table table-bordered table-stripped`}>
            <thead className="table-light">
              <tr>
                <th width={'190'} >Previous Company Name</th>
                <th width={'160'} >Previous Designation</th>
                <th width={'200'} >Work Experience</th>
                <th width={'150'} >Last CTC</th>
                <th width={'200'} >References</th>
                {/* <th className="text-center">Action</th> */}

              </tr>
            </thead>
            {this.state.data?.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan={12}>
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            ) : (
            <tbody>
              {this.state.data.map((row) => {
                var references_obj = JSON.parse(row.employee_work_experience_references);
                return (
                  <tr key={row.employee_work_experience_id}>
                    <td>{row.company_name}</td>
                    <td>{row.last_designation}</td>
                    <td>{row.experience_period}</td>
                    <td>{row.last_ctc}</td>
                    <td>
                      <div>
                        <ol style={{paddingLeft:"10px"}}>
                          {Object.entries(references_obj).map(([key, value], index) => (
                            <li key={index}>
                              {value.name !== '' && (
                                <>
                                  <h6 style={{marginBottom:"0px"}}>{value.name}</h6>
                                  <br />
                                  <small>Contact: {value.contact}</small>
                                  <br />
                                  <small>Email: {value.email}</small>
                                  <hr />
                                </>
                              )}
                            </li>
                          ))}
                        </ol>
                      </div>

                    </td>
                    {/* <td >
                      <div className="d-flex justify-content-around">

                        <button
                          onClick={() =>
                            this.handleDelete(row.employee_work_experience_id)
                          }
                          className="btn-icon btn btn-sm btn-outline-danger"
                        >
                          <i className="ri-delete-bin-line"></i>{" "}
                        </button>
                      </div>
                    </td> */}
                  </tr>
                );
              })}
            </tbody>)
  }
            {/* <tfoot className="table-light">
              <tr>
                <th colSpan={6}>
                  <div className="d-flex justify-content-between">
                    <button
                      disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                      type="button"
                      onClick={() => this.handlePrev()}
                      className={`btn btn-warning btn-label waves-effect waves-light`}
                    >
                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                      Previous
                    </button>
                    <div
                      className="col-md-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {
                        <small>
                          Total Records: {this.state.total_records} |
                          Total Pages: {this.state.total_pages} |
                          Current Page: {this.state.page}
                        </small>
                      }
                    </div>
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        onChange={(e) => this.handleChange(e)}
                      >
                        {Array.from(
                          { length: this.state.total_pages },
                          (_, i) => (
                            <option
                              selected={this.state.page === i + 1}
                              key={i}
                              value={i + 1}
                            >
                              Page {i + 1}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                    <button
                      disabled={
                        this.state.next === false &&
                          this.state.loadingList === false
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => this.handleNext()}
                      className={`btn btn-primary btn-label waves-effect right waves-light`}
                    >
                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                      Next
                    </button>
                  </div>
                </th>
              </tr>
            </tfoot> */}
          </table>
        </div>
      </>
    );
  }
}

export default withRouter(WorkExperienceView);
